module.exports = __webpack_public_path__ + "static/media/Skill_hub_thumbnail.31f20414.png";